import type { ClientItem } from 'owa-mail-store';

// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS2322 (6,62): Type 'boolean | undefined' is not assignable to type 'boolean'.
// @ts-expect-error
export const isSmimeDecoded = (item: ClientItem): boolean => item?.Smime?.isDecoded;

export default isSmimeDecoded;
